import React from "react";
import { MarkerType } from "react-flow-renderer";

const level1 = "rgb(17, 3, 3, 0.1)";
const level2 = "#f5cc7f";
const level3 = "rgb(0, 25, 59, 0.9)";
const level4 = "#003379";
const level5 = "#0a0f17";
const level6 = "#de723a";
const black = "yellow";
const white = "white";
const transparent = "00FFFFFF";
const spaceColor = "#141c26";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>Quick Tips</strong>
          <p>Full of common CSS Solutions</p>
        </>
      ),
    },
    position: { x: 0, y: 0 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "2",
    data: {
      label: (
        <>
          <strong>Center an element</strong>
          <p></p>
          <iframe
            height="400"
            width="100%"
            scrolling="no"
            title="Untitled"
            src="https://codepen.io/jonathanelias1/embed/preview/xxjovVb?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/xxjovVb">Untitled</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 0, y: 320 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "3",
    data: {
      label: (
        <>
          <strong>Position Text Over an Image</strong>
          <p>
            The quickest way to do this is to use position absolute and then
            position your text over the image with top, bottom, left, right
            properties.
          </p>

          <iframe
            height="1000"
            width="100%"
            scrolling="no"
            title="Center an element"
            src="https://codepen.io/jonathanelias1/embed/preview/poVXMeq?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/poVXMeq">
              Center an element
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1272, y: 320 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },

  {
    id: "4",

    data: {
      label: (
        <>
          <strong>Starting from scratch reccommendations</strong>
          <p className="">Use :root and box-sizing:border-box</p>
          <iframe
            height="1000"
            width="100%"
            scrolling="no"
            title="Position Text Over an image"
            src="https://codepen.io/jonathanelias1/embed/preview/YzLomEV?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/YzLomEV">
              Position Text Over an image
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1008, y: 320 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },

  // End of items
];

export const edges = [
  {
    id: "e1-2",
    source: "1",
    target: "2",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-3",
    source: "1",
    target: "3",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-4",
    source: "1",
    target: "4",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //   {
  //     id: "e8-10",
  //     source: "8",
  //     target: "10",
  //     animated: true,
  //     style: { stroke: "#f6ab6c" },
  //     markerEnd: {
  //       type: MarkerType.ArrowClosed,
  //     },
  //   },

  //END
];
